module.exports = __webpack_public_path__ + "static/media/F2P_Thumbnail.aa2d3816.png";